export const COMPANY_TESTER = 'Company Tester';
export const COMPANY_ADMIN = 'Company Admin';
export const SPRUCE_ADMIN = 'Spruce Admin';
export const DYNAMIC_LAYOUT_ADMIN = 'Dynamic Layout Admin';

export const ALL_ROLES = [
  COMPANY_TESTER,
  COMPANY_ADMIN,
  SPRUCE_ADMIN
];

export const COMPANY_ADMINS = [
  COMPANY_ADMIN
];

export const SPRUCE_ADMINS = [
  SPRUCE_ADMIN
];

export const COMPANY_TESTERS = [
  COMPANY_TESTER
];

export const ADMINS = [
  ...COMPANY_ADMINS,
  ...SPRUCE_ADMINS
];

export const DYNAMIC_LAYOUT_ADMINS = [
  DYNAMIC_LAYOUT_ADMIN,
  ...SPRUCE_ADMINS,
];

export const COMPANY_ROLES = [
  ...COMPANY_ADMINS,
  ...COMPANY_TESTERS,
];



// WEBPACK FOOTER //
// src/constants/userRoles.js